import { useCallback } from 'react';

/**
 * Hook for URL navigation utilities.
 *
 * @returns {Object} Navigation utilities including `buildUrl` and `navigate`.
 *
 * @example
 * const { buildUrl, navigate } = useUrlNavigation();
 * const url = buildUrl('/path', new URLSearchParams({ key: 'value' }));
 * navigate(url);
 */
export function useUrlNavigation() {
  const buildUrl = useCallback((path: string, params: URLSearchParams) => {
    const query = params.toString();
    return `${path}${query ? `?${query}` : ''}`;
  }, []);

  const navigate = useCallback((url: string, replace: boolean = false) => {
    if (replace) {
      window.history.replaceState({}, '', url);
    } else {
      window.history.pushState({}, '', url);
    }
    window.dispatchEvent(new PopStateEvent('popstate'));
  }, []);

  return {
    buildUrl,
    navigate,
  };
}
